import React, { useState, useEffect, useRef, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  adminLogout,
  setUsers,
  setAllTrades,
  setAllDeposits,
  setAllWithdrawals,
  setStats,
  setAllStaff,
} from "../../store/adminSlice";
import { updateMarketData } from "../../store/tradeSlice";
import { showToast } from "../../store/uiSlice";
import { fmtUSD } from "../../utils/formatters";
import { INSTRUMENTS } from "../../utils/constants";
import UsersManagement from "../../pages/admin/UsersManagement.jsx";
import AllTrades from "../../pages/admin/AllTrades.jsx";
import DepositsWithdrawals from "../../pages/admin/DepositsWithdrawals";
import KycVerification from "../../pages/admin/KycVerification";
import StaffManagement from "../../pages/admin/StaffManagement";
import CreditManagement from "../../pages/admin/CreditManagement";
import LeadManagement from "../../pages/admin/LeadManagement";
import GroxionLead from "../../pages/admin/GroxionLead";
import RetentionLead from "../../pages/admin/RetentionLead";
import RetentionData from "../../pages/admin/RetentionData"; // <-- NEW IMPORT
import StaffLeadPanel from "../../pages/admin/StaffLeadPanel";
import ManagerLeadPanel from "../../pages/admin/ManagerLeadPanel";
import TeamLeadsList from "../../pages/admin/TeamLeadsList";
import TeamLeadPanel from "../../pages/admin/TeamLeadPanel";
import Settings from "../../pages/admin/Settings";
import SwapManagement from "./SwapManagement";
import AffiliateList from "./AffiliateList";
import MissedCalls from "../../pages/admin/MissedCalls";
import StaffInbox from "../../pages/admin/StaffInbox";
import AdminMasterInbox from "../../pages/admin/AdminMasterInbox";
import SentEmails from "../../pages/admin/SentEmails"; // <-- ADDED
import { adminApi, default as api } from "../../services/api";
import { io } from "socket.io-client";

const FontStyles = () => (
  <style>{`
    @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700;800;900&display=swap');
    @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800;900&display=swap');
    @import url('https://fonts.googleapis.com/css2?family=Space+Grotesk:wght@300;400;500;600;700&display=swap');
  `}</style>
);

const CelebrationPopup = ({ notification, onClose }) => {
  const [visible, setVisible] = useState(false);
  const [exiting, setExiting] = useState(false);
  const [textVisible, setTextVisible] = useState(false);
  const particlesRef = useRef([]);

  useEffect(() => {
    const colors = [
      "#1e3a5f",
      "#f97316",
      "#059669",
      "#2563eb",
      "#fbbf24",
      "#ec4899",
      "#10b981",
      "#8b5cf6",
      "#ef4444",
      "#6366f1",
      "#14b8a6",
      "#f59e0b",
      "#06b6d4",
      "#d946ef",
      "#84cc16",
      "#f43f5e",
      "#fbbf24",
      "#3b82f6",
      "#22c55e",
      "#e11d48",
    ];
    const parts = [];
    for (let i = 0; i < 400; i++) {
      parts.push({
        id: `l-${i}`,
        x: -10,
        y: Math.random() * 100,
        size: 8 + Math.random() * 20,
        color: colors[Math.floor(Math.random() * colors.length)],
        delay: Math.random() * 1.5,
        duration: 3 + Math.random() * 4,
        driftX: 600 + Math.random() * 1000,
        driftY: (Math.random() - 0.5) * 800,
        rotation: Math.random() * 1000,
      });
    }
    for (let i = 0; i < 400; i++) {
      parts.push({
        id: `r-${i}`,
        x: 110,
        y: Math.random() * 100,
        size: 8 + Math.random() * 20,
        color: colors[Math.floor(Math.random() * colors.length)],
        delay: Math.random() * 1.5,
        duration: 3 + Math.random() * 4,
        driftX: -(600 + Math.random() * 1000),
        driftY: (Math.random() - 0.5) * 800,
        rotation: Math.random() * 1000,
      });
    }
    for (let i = 0; i < 200; i++) {
      parts.push({
        id: `t-${i}`,
        x: Math.random() * 100,
        y: -5,
        size: 6 + Math.random() * 14,
        color: colors[Math.floor(Math.random() * colors.length)],
        delay: Math.random() * 1,
        duration: 3 + Math.random() * 5,
        driftX: (Math.random() - 0.5) * 400,
        driftY: 500 + Math.random() * 500,
        rotation: Math.random() * 700,
      });
    }
    particlesRef.current = parts;
    try {
      const audio = new Audio(
        "data:audio/wav;base64,UklGRnoGAABXQVZFZm10IBAAAAABAAEAQB8AAEAfAAABAAgAZGF0YQoGAACAf39/f4B/f3+Af39/gH9/f4B/f3+Af39/gH9/f4B/f3+Af39/gH9/f4B/f3+Af39/gH9/f4B/f3+Af39/gH9/f4B/f3+Af39/gH9/f4B/f3+Af39/gH9/f4B/f3+Af39/gH9/f4B/f3+Af39/gH9/f4B/f3+Af39/gH9/f4B/f3+Af39/gH9/f4B/f3+Af39/gH9/f4B/f3+Af39/gH9/f4B/f3+Af39/gH9/f4B/f3+Af39/gH9/f4B/f3+Af39/gH9/f4B/f3+Af39/gH9/f4B/f3+Af39/gH9/f4B/f3+Af39/gH9/f4B/f3+Af39/gH9/f4B/f3+Af39/gH9/f4B/f3+Af39/gH9/f4B/f3+Af39/gH9/f4B/f3+Af39/gH9/f4B/f3+Af39/gH9/f4B/f3+Af39/gA==",
      );
      audio.volume = 0.25;
      audio.play().catch(() => {});
    } catch (e) {}
    setVisible(true);
    setTimeout(() => setTextVisible(true), 300);
    const timer = setTimeout(() => {
      setExiting(true);
      setTextVisible(false);
      setTimeout(() => onClose(), 600);
    }, 7000);
    return () => clearTimeout(timer);
  }, []);

  if (!notification) return null;

  const isFTD = notification.depositType === "ftd";
  const amountColor = isFTD ? "#dc2626" : "#059669";

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center pointer-events-none">
      <div className="fixed inset-0 overflow-hidden" style={{ zIndex: 1 }}>
        {particlesRef.current.map((p) => (
          <div
            key={p.id}
            className="absolute"
            style={{
              left: `${p.x}%`,
              top: `${p.y}%`,
              width: `${p.size}px`,
              height: `${p.size}px`,
              backgroundColor: p.color,
              borderRadius: "50%",
              opacity: 0,
              animation: `shoot ${p.duration}s ease-out ${p.delay}s forwards`,
              "--dx": `${p.driftX}px`,
              "--dy": `${p.driftY}px`,
              "--rt": `${p.rotation}deg`,
            }}
          />
        ))}
      </div>
      <div
        className={`relative z-10 transition-all duration-700 transform ${visible && !exiting ? "scale-100 opacity-100" : "scale-90 opacity-0"}`}
      >
        <div className="text-center px-4 md:px-10 py-6 md:py-8">
          <h2
            className={`font-extrabold mb-4 md:mb-6 transition-all duration-1000 transform ${textVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}
            style={{
              fontFamily: "'Poppins', sans-serif",
              color: "#0b1e33",
              textShadow:
                "0 2px 4px rgba(0,0,0,0.1), 0 0 30px rgba(255,255,255,0.9), 0 0 60px rgba(255,255,255,0.7)",
              letterSpacing: "-0.5px",
              lineHeight: "1.2",
              fontSize: "clamp(1.5rem, 6vw, 4.5rem)",
              transitionDelay: "0.2s",
            }}
          >
            <span
              className="inline-block transition-all duration-1000 transform"
              style={{
                color: "#1e3a5f",
                transitionDelay: "0.3s",
                opacity: textVisible ? 1 : 0,
                transform: textVisible
                  ? "translateY(0) scale(1)"
                  : "translateY(20px) scale(0.9)",
              }}
            >
              {notification.agentName}
            </span>{" "}
            <span
              className="inline-block transition-all duration-1000"
              style={{
                transitionDelay: "0.5s",
                opacity: textVisible ? 1 : 0,
                transform: textVisible ? "translateY(0)" : "translateY(15px)",
              }}
            >
              {isFTD ? "made a FTD of" : "made a deposit of"}
            </span>
          </h2>
          <div
            className={`transition-all duration-1000 transform ${textVisible ? "opacity-100 translate-y-0 scale-100" : "opacity-0 translate-y-8 scale-90"}`}
            style={{ transitionDelay: "0.7s" }}
          >
            <span
              className="inline-block font-extrabold transition-all duration-1000"
              style={{
                fontFamily: "'Space Grotesk', monospace",
                color: amountColor,
                fontSize: "clamp(2.5rem, 12vw, 10rem)",
                textShadow:
                  "0 2px 4px rgba(5, 150, 105, 0.2), 0 0 30px rgba(255,255,255,0.9), 0 0 60px rgba(255,255,255,0.7)",
                letterSpacing: "-2px",
                lineHeight: "1",
                opacity: textVisible ? 1 : 0,
                transform: textVisible
                  ? "translateY(0) scale(1)"
                  : "translateY(30px) scale(0.8)",
              }}
            >
              ${Number(notification.amount).toLocaleString()}
            </span>
          </div>
        </div>
      </div>
      <style>{`@keyframes shoot{0%{opacity:1;transform:translateX(0) translateY(0) rotate(0deg) scale(1)}50%{opacity:0.8;transform:translateX(calc(var(--dx)*0.5)) translateY(calc(var(--dy)*0.5)) rotate(calc(var(--rt)*0.5)) scale(0.7)}100%{opacity:0;transform:translateX(var(--dx)) translateY(var(--dy)) rotate(var(--rt)) scale(0)}}`}</style>
    </div>
  );
};

const NotificationsTab = () => {
  const [agentName, setAgentName] = useState("");
  const [amount, setAmount] = useState("");
  const [depositType, setDepositType] = useState("deposit");
  const [sending, setSending] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const dispatch = useDispatch();
  useEffect(() => {
    setTimeout(() => setIsVisible(true), 100);
  }, []);

  const handleSend = async () => {
    if (!agentName.trim() || !amount || Number(amount) <= 0) {
      dispatch(showToast({ message: "Please fill all fields", type: "error" }));
      return;
    }
    setSending(true);
    try {
      await adminApi.post("/admin/deposit-notification", {
        agentName: agentName.trim(),
        clientName: agentName.trim(),
        amount: Number(amount),
        depositType,
      });
      dispatch(
        showToast({ message: "Notification broadcast!", type: "success" }),
      );
      setAgentName("");
      setAmount("");
      setDepositType("deposit");
    } catch (e) {
      dispatch(showToast({ message: "Failed", type: "error" }));
    } finally {
      setSending(false);
    }
  };

  const isFTD = depositType === "ftd";
  const btnColor = isFTD
    ? "from-[#dc2626] to-[#ef4444] border-[#b91c1c]"
    : "from-[#1e3a5f] to-[#2563eb] border-[#0b1e33]";

  return (
    <div className="p-3 md:p-8">
      <FontStyles />
      <div className="max-w-lg mx-auto">
        <div
          className={`text-center mb-6 md:mb-8 transition-all duration-1000 transform ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}
        >
          <div
            className="w-14 h-14 md:w-16 md:h-16 rounded-2xl bg-gradient-to-br from-[#1e3a5f] to-[#2563eb] flex items-center justify-center mx-auto mb-3 md:mb-4 shadow-lg shadow-[#1e3a5f]/30 transition-all duration-700 hover:scale-110 hover:rotate-12"
            style={{ transitionDelay: "0.2s" }}
          >
            <i className="fas fa-bell text-white text-xl md:text-2xl" />
          </div>
          <h3
            className="text-xl md:text-3xl font-extrabold uppercase tracking-tight transition-all duration-700"
            style={{
              fontFamily: "'Poppins', sans-serif",
              letterSpacing: "-0.5px",
              color: "#0b1e33",
              transitionDelay: "0.3s",
            }}
          >
            Broadcast Notification
          </h3>
          <p
            className="font-medium text-sm md:text-base mt-1 md:mt-2 transition-all duration-700"
            style={{
              fontFamily: "'Inter', sans-serif",
              color: "#475569",
              transitionDelay: "0.4s",
            }}
          >
            Send deposit alerts to all connected clients
          </p>
        </div>
        <div
          className={`bg-white border-2 border-[#e2e8f0] rounded-2xl p-4 md:p-8 space-y-4 md:space-y-6 shadow-xl shadow-slate-200/50 transition-all duration-1000 transform ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}
          style={{ transitionDelay: "0.5s" }}
        >
          <div
            className="transition-all duration-700 transform"
            style={{ transitionDelay: "0.5s", opacity: isVisible ? 1 : 0 }}
          >
            <label
              className="text-xs md:text-sm font-bold uppercase tracking-wider block mb-2 md:mb-3"
              style={{
                fontFamily: "'Inter', sans-serif",
                letterSpacing: "1.5px",
                color: "#0f172a",
              }}
            >
              Notification Type
            </label>
            <div className="flex flex-col sm:flex-row gap-2">
              <button
                onClick={() => setDepositType("deposit")}
                className={`flex-1 py-2.5 md:py-3 rounded-xl font-bold text-xs md:text-sm uppercase tracking-wider transition-all duration-300 border-2 ${depositType === "deposit" ? "bg-[#059669] text-white border-[#047857]" : "bg-[#f8fafc] text-[#64748b] border-[#cbd5e1] hover:border-[#059669] hover:text-[#059669]"}`}
                style={{
                  fontFamily: "'Inter', sans-serif",
                  letterSpacing: "1px",
                }}
              >
                <i className="fas fa-circle-plus mr-2" /> Deposit
              </button>
              <button
                onClick={() => setDepositType("ftd")}
                className={`flex-1 py-2.5 md:py-3 rounded-xl font-bold text-xs md:text-sm uppercase tracking-wider transition-all duration-300 border-2 ${depositType === "ftd" ? "bg-[#dc2626] text-white border-[#b91c1c]" : "bg-[#f8fafc] text-[#64748b] border-[#cbd5e1] hover:border-[#dc2626] hover:text-[#dc2626]"}`}
                style={{
                  fontFamily: "'Inter', sans-serif",
                  letterSpacing: "1px",
                }}
              >
                <i className="fas fa-star mr-2" /> FTD
              </button>
            </div>
          </div>
          <div
            className="transition-all duration-700 transform"
            style={{
              transitionDelay: "0.6s",
              opacity: isVisible ? 1 : 0,
              transform: isVisible ? "translateX(0)" : "translateX(-20px)",
            }}
          >
            <label
              className="text-xs md:text-sm font-bold uppercase tracking-wider block mb-2"
              style={{
                fontFamily: "'Inter', sans-serif",
                letterSpacing: "1.5px",
                color: "#0f172a",
              }}
            >
              Agent Name{" "}
              <span style={{ color: "#dc2626" }} className="ml-1">
                *
              </span>
            </label>
            <div className="relative">
              <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none">
                <i
                  className="fas fa-user-tie text-sm"
                  style={{ color: "#64748b" }}
                />
              </div>
              <input
                type="text"
                value={agentName}
                onChange={(e) => setAgentName(e.target.value)}
                placeholder="e.g. John Smith"
                className="w-full bg-[#f8fafc] border-2 border-[#cbd5e1] rounded-xl pl-10 md:pl-11 pr-3 md:pr-4 py-3 md:py-3.5 text-sm md:text-base font-semibold outline-none focus:border-[#1e3a5f] focus:bg-white focus:ring-4 focus:ring-[#1e3a5f]/10 transition-all duration-300"
                style={{ fontFamily: "'Inter', sans-serif", color: "#0f172a" }}
              />
            </div>
          </div>
          <div
            className="transition-all duration-700 transform"
            style={{
              transitionDelay: "0.7s",
              opacity: isVisible ? 1 : 0,
              transform: isVisible ? "translateX(0)" : "translateX(-20px)",
            }}
          >
            <label
              className="text-xs md:text-sm font-bold uppercase tracking-wider block mb-2"
              style={{
                fontFamily: "'Inter', sans-serif",
                letterSpacing: "1.5px",
                color: "#0f172a",
              }}
            >
              Deposit Amount{" "}
              <span style={{ color: "#dc2626" }} className="ml-1">
                *
              </span>
            </label>
            <div className="relative">
              <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none">
                <span
                  className="font-bold text-lg md:text-xl"
                  style={{
                    fontFamily: "'Space Grotesk', monospace",
                    color: "#475569",
                  }}
                >
                  $
                </span>
              </div>
              <input
                type="number"
                value={amount}
                onChange={(e) => setAmount(e.target.value)}
                placeholder="0.00"
                min="1"
                step="0.01"
                className="w-full bg-[#f8fafc] border-2 border-[#cbd5e1] rounded-xl pl-9 md:pl-10 pr-12 md:pr-16 py-3 md:py-3.5 text-lg md:text-xl font-bold outline-none focus:border-[#059669] focus:bg-white focus:ring-4 focus:ring-[#059669]/10 transition-all duration-300"
                style={{
                  fontFamily: "'Space Grotesk', monospace",
                  color: "#0f172a",
                }}
              />
              <div className="absolute inset-y-0 right-0 pr-3 md:pr-4 flex items-center pointer-events-none">
                <span
                  className="text-xs md:text-sm font-semibold"
                  style={{
                    fontFamily: "'Inter', sans-serif",
                    color: "#64748b",
                  }}
                >
                  USD
                </span>
              </div>
            </div>
          </div>
          <div
            className="flex flex-col sm:flex-row gap-2 md:gap-3 pt-1 md:pt-2 transition-all duration-700 transform"
            style={{
              transitionDelay: "0.8s",
              opacity: isVisible ? 1 : 0,
              transform: isVisible ? "translateY(0)" : "translateY(15px)",
            }}
          >
            <button
              type="button"
              onClick={() => {
                setAgentName("");
                setAmount("");
              }}
              className="flex-1 py-3 md:py-4 rounded-xl bg-[#f1f5f9] border-2 border-[#cbd5e1] font-bold text-sm md:text-base uppercase tracking-wider hover:bg-[#e2e8f0] hover:border-[#94a3b8] transition-all duration-300 active:scale-[0.98]"
              style={{
                fontFamily: "'Inter', sans-serif",
                letterSpacing: "1px",
                color: "#334155",
              }}
            >
              <i className="fas fa-undo mr-2" /> Clear
            </button>
            <button
              onClick={handleSend}
              disabled={sending}
              className={`flex-[2] py-3 md:py-4 rounded-xl bg-gradient-to-r ${btnColor} text-white font-bold text-sm md:text-base uppercase tracking-wider hover:shadow-xl transition-all duration-300 disabled:opacity-50 disabled:cursor-not-allowed border-b-[3px] flex items-center justify-center gap-2 active:scale-[0.98]`}
              style={{
                fontFamily: "'Poppins', sans-serif",
                letterSpacing: "1px",
              }}
            >
              {sending ? (
                <>
                  <span className="w-4 h-4 md:w-5 md:h-5 border-2 border-white border-t-transparent rounded-full animate-spin" />
                  <span>Sending...</span>
                </>
              ) : (
                <>
                  <i className="fas fa-paper-plane mr-2" />
                  <span>Broadcast Alert</span>
                </>
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

const AdminDashboard = () => {
  const dispatch = useDispatch();
  const { adminUser, adminPermissions, stats } = useSelector(
    (state) => state.admin,
  );
  const [activeTab, setActiveTab] = useState("leads");
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [mobileSidebarOpen, setMobileSidebarOpen] = useState(false);
  const [adminNotifications, setAdminNotifications] = useState([]);
  const [showNotifPanel, setShowNotifPanel] = useState(false);
  const [unreadAdminNotifs, setUnreadAdminNotifs] = useState(0);
  const [isRefreshing, setIsRefreshing] = useState(false);
  const [onlineUsers, setOnlineUsers] = useState([]);
  const [celebration, setCelebration] = useState(null);
  const notifPanelRef = useRef(null);
  const socketRef = useRef(null);
  const storeRef = useRef({});
  const tickTimerRef = useRef(null);

  const storedUser = localStorage.getItem("adminUser");
  const user = adminUser || (storedUser ? JSON.parse(storedUser) : null);

  // ── Role helpers ─────────────────────────────────────────────────────────
  const isSuperAdmin = user?.role === "super_admin";
  const isAdminLike = user?.role === "super_admin" || user?.role === "admin";
  const isStaff = user?.role === "staff";
  const isManager = user?.role === "manager";
  const isTeamLead = user?.role === "team_lead";

  const hasPermission = (key) => {
    if (isSuperAdmin) return true;
    if (!adminPermissions) return false;
    return adminPermissions[key] === true;
  };

  const fetchMarketData = useCallback(async () => {
    try {
      const symbols = INSTRUMENTS.map((i) => i.id).join(",");
      const response = await api.get(`/market/quotes?symbols=${symbols}`);
      const raw = response.data;
      const dataMap = {};
      if (Array.isArray(raw)) {
        raw.forEach((q) => {
          if (q?.symbol) dataMap[q.symbol] = q;
        });
      } else if (raw && typeof raw === "object") {
        Object.entries(raw).forEach(([sym, q]) => {
          if (q?.price) dataMap[sym] = { ...q, symbol: sym };
        });
      }
      storeRef.current = dataMap;
      dispatch(updateMarketData(dataMap));
    } catch (err) {}
  }, [dispatch]);

  const startTickSimulation = useCallback(() => {
    if (tickTimerRef.current) clearInterval(tickTimerRef.current);
    tickTimerRef.current = setInterval(() => {
      const next = { ...storeRef.current };
      let updated = false;
      INSTRUMENTS.forEach((inst) => {
        const d = next[inst.id];
        if (!d?.price) return;
        const vol =
          inst.cat === "crypto"
            ? 0.002
            : inst.cat === "forex"
              ? 0.00025
              : 0.0008;
        const move = (Math.random() - 0.499) * 2 * vol * d.price;
        const newPrice = Math.max(d.price + move, 0.00001);
        next[inst.id] = {
          ...d,
          prev: d.price,
          price: newPrice,
          high: Math.max(d.high || d.price, newPrice),
          low: Math.min(d.low || d.price, newPrice),
          change: newPrice - d.price,
          changePct: d.price ? ((newPrice - d.price) / d.price) * 100 : 0,
        };
        updated = true;
      });
      if (updated) {
        storeRef.current = next;
        dispatch(updateMarketData(next));
      }
    }, 4000);
  }, [dispatch]);

  useEffect(() => {
    fetchMarketData().then(() => startTickSimulation());
    return () => {
      if (tickTimerRef.current) clearInterval(tickTimerRef.current);
    };
  }, []);

  const fetchOnlineUsers = async () => {
    try {
      const res = await adminApi.get("/admin/users/online");
      setOnlineUsers(res.data.onlineUserIds || []);
    } catch (e) {}
  };

  const fetchDashboardData = useCallback(
    async (silent = false) => {
      if (!silent) setIsRefreshing(true);
      try {
        const requests = [
          adminApi.get("/admin/stats"),
          adminApi.get("/admin/deposits"),
          adminApi.get("/admin/withdrawals"),
        ];
        if (!adminPermissions || adminPermissions.users !== false)
          requests.push(adminApi.get("/admin/users?limit=1000"));
        if (!adminPermissions || adminPermissions.trades !== false)
          requests.push(adminApi.get("/admin/trades"));
        const results = await Promise.all(requests);
        const [statsRes, depositsRes, withdrawalsRes, usersRes, tradesRes] =
          results;

        if (usersRes) {
          const d = usersRes.data;
          dispatch(setUsers(Array.isArray(d) ? d : d?.users || d?.data || []));
        }
        if (tradesRes) {
          const d = tradesRes.data;
          dispatch(
            setAllTrades(Array.isArray(d) ? d : d?.trades || d?.data || []),
          );
        }
        dispatch(
          setAllDeposits(
            Array.isArray(depositsRes.data)
              ? depositsRes.data
              : depositsRes.data?.deposits || depositsRes.data?.data || [],
          ),
        );
        dispatch(
          setAllWithdrawals(
            Array.isArray(withdrawalsRes.data)
              ? withdrawalsRes.data
              : withdrawalsRes.data?.withdrawals ||
                  withdrawalsRes.data?.data ||
                  [],
          ),
        );

        const s = statsRes.data;
        dispatch(
          setStats({
            totalUsers: s?.users?.totalUsers || s?.totalUsers || 0,
            totalDeposits: s?.finances?.totalDeposits || s?.totalDeposits || 0,
            totalWithdrawals:
              s?.finances?.totalWithdrawals || s?.totalWithdrawals || 0,
            totalVolume: s?.trading?.totalBuyVolume || s?.totalVolume || 0,
            activeTraders: s?.users?.active30Days || s?.activeTraders || 0,
            totalTrades: s?.trading?.totalTrades || s?.totalTrades || 0,
            totalDepositsCount:
              s?.finances?.totalDepositCount || s?.totalDepositsCount || 0,
            totalWithdrawalsCount:
              s?.finances?.totalWithdrawalCount ||
              s?.totalWithdrawalsCount ||
              0,
          }),
        );

        if (isAdminLike || isManager || isTeamLead) {
          try {
            const sr = await adminApi.get("/admin/staff");
            dispatch(setAllStaff(sr.data?.staff || []));
          } catch (e) {}
        }
      } catch (error) {
        if (!silent)
          dispatch(
            showToast({
              message: "Failed to load dashboard data",
              type: "error",
            }),
          );
      } finally {
        setIsRefreshing(false);
      }
    },
    [dispatch, isAdminLike, isManager, isTeamLead, adminPermissions],
  );

  useEffect(() => {
    fetchDashboardData();
    fetchOnlineUsers();
    connectAdminSocket();
    return () => {
      if (socketRef.current) {
        socketRef.current.disconnect();
        socketRef.current = null;
      }
    };
  }, []);

  useEffect(() => {
    const h = (e) => {
      if (notifPanelRef.current && !notifPanelRef.current.contains(e.target))
        setShowNotifPanel(false);
    };
    document.addEventListener("mousedown", h);
    return () => document.removeEventListener("mousedown", h);
  }, []);

  const connectAdminSocket = () => {
    try {
      const socket = io(
        import.meta.env.VITE_WS_URL || "http://localhost:3000",
        {
          auth: { token: localStorage.getItem("adminToken") },
          transports: ["websocket", "polling"],
        },
      );

      socket.on("admin_notification", (data) => {
        setAdminNotifications((prev) => [data, ...prev].slice(0, 50));
        setUnreadAdminNotifs((prev) => prev + 1);
        dispatch(
          showToast({
            message:
              data.type === "withdrawal_request"
                ? `💰 ${data.message}`
                : data.type === "credit_request"
                  ? `💳 ${data.message}`
                  : `${data.userName} → ${data.pageTitle}`,
            type:
              data.type === "withdrawal_request"
                ? "error"
                : data.type === "credit_request"
                  ? "info"
                  : data.page === "/deposit"
                    ? "success"
                    : "info",
            duration: 5000,
          }),
        );
        if (
          data.type === "withdrawal_request" ||
          data.type === "credit_request"
        )
          fetchDashboardData(true);
      });

      socket.on("deposit_celebration", (data) => {
        setCelebration(data);
      });

      socket.on("user_status_change", (data) => {
        if (data.status === "online")
          setOnlineUsers((prev) =>
            prev.includes(data.userId) ? prev : [...prev, data.userId],
          );
        else setOnlineUsers((prev) => prev.filter((id) => id !== data.userId));
      });

      socketRef.current = socket;
    } catch (e) {}
  };

  // ── Menu building ────────────────────────────────────────────────────────
  const menuItems = [];

  // 1. Every Team Lead always gets their own desk
  if (isTeamLead) {
    menuItems.push({
      id: "team-lead-panel",
      label: "My Team Desk",
      icon: "fa-user-tie",
      count: null,
    });
  }

  // 2. TLs, Staff, and Managers all share the same permission-based menu
  if (isTeamLead || isStaff || isManager) {
    if (!isTeamLead) {
      menuItems.push({
        id: "leads",
        label: "My Leads",
        icon: "fa-user-plus",
        count: null,
      });
    }

    menuItems.push({
      id: "missed_calls",
      label: "Missed Calls",
      icon: "fa-phone-slash",
      count: null,
    });
    menuItems.push({
      id: "inbox",
      label: "Inbox",
      icon: "fa-inbox",
      count: null,
    });

    if (hasPermission("users"))
      menuItems.push({
        id: "users",
        label: "Users",
        icon: "fa-users",
        count: stats.totalUsers,
      });
    if (hasPermission("kyc"))
      menuItems.push({
        id: "kyc",
        label: "KYC",
        icon: "fa-shield-alt",
        count: null,
      });
    if (hasPermission("credit"))
      menuItems.push({
        id: "credit",
        label: "Credit",
        icon: "fa-credit-card",
        count: null,
      });
    if (hasPermission("trades"))
      menuItems.push({
        id: "trades",
        label: "All Trades",
        icon: "fa-chart-line",
        count: stats.totalTrades,
      });
    if (hasPermission("deposits"))
      menuItems.push({
        id: "deposits",
        label: "Deposits",
        icon: "fa-circle-plus",
        count: stats.totalDepositsCount,
      });
    if (hasPermission("withdrawals"))
      menuItems.push({
        id: "withdrawals",
        label: "Withdrawals",
        icon: "fa-circle-minus",
        count: stats.totalWithdrawalsCount,
      });
    if (hasPermission("settings"))
      menuItems.push({
        id: "settings",
        label: "Settings",
        icon: "fa-gear",
        count: undefined,
      });
  } else {
    // Admin / super_admin
    if (hasPermission("users"))
      menuItems.push({
        id: "users",
        label: "Users",
        icon: "fa-users",
        count: stats.totalUsers,
      });
    if (hasPermission("staff"))
      menuItems.push({
        id: "staff",
        label: "Staff",
        icon: "fa-user-tie",
        count: null,
      });
    if (hasPermission("team_leads") || isSuperAdmin)
      menuItems.push({
        id: "team_leads",
        label: "Team Leads",
        icon: "fa-sitemap",
        count: null,
      });
    if (hasPermission("leads"))
      menuItems.push({
        id: "leads",
        label: "Leads (Staging)",
        icon: "fa-box-archive",
        count: null,
      });
    if (hasPermission("groxion_leads"))
      menuItems.push({
        id: "groxion_leads",
        label: "Anzo Leads",
        icon: "fa-check-circle",
        count: null,
      });
    if (hasPermission("retention_leads"))
      menuItems.push({
        id: "retention_leads",
        label: "Retention Leads",
        icon: "fa-lock",
        count: null,
      });
    // ─── NEW: Retention Data Tab ───
    menuItems.push({
      id: "retention_data",
      label: "Retention Data",
      icon: "fa-database",
      count: null,
    });
    // ─── End NEW ───
    if (hasPermission("affiliates"))
      menuItems.push({
        id: "affiliates",
        label: "Affiliates",
        icon: "fa-users-gear",
        count: null,
      });
    if (hasPermission("kyc"))
      menuItems.push({
        id: "kyc",
        label: "KYC",
        icon: "fa-shield-alt",
        count: null,
      });
    if (hasPermission("credit"))
      menuItems.push({
        id: "credit",
        label: "Credit",
        icon: "fa-credit-card",
        count: null,
      });
    if (hasPermission("trades"))
      menuItems.push({
        id: "trades",
        label: "All Trades",
        icon: "fa-chart-line",
        count: stats.totalTrades,
      });
    if (hasPermission("deposits"))
      menuItems.push({
        id: "deposits",
        label: "Deposits",
        icon: "fa-circle-plus",
        count: stats.totalDepositsCount,
      });
    if (hasPermission("withdrawals"))
      menuItems.push({
        id: "withdrawals",
        label: "Withdrawals",
        icon: "fa-circle-minus",
        count: stats.totalWithdrawalsCount,
      });
    if (hasPermission("swap"))
      menuItems.push({
        id: "swap",
        label: "Swap",
        icon: "fa-rotate",
        count: null,
      });

    // Master Inbox for Admin/Super Admin
    if (isAdminLike) {
      menuItems.push({
        id: "master_inbox",
        label: "Master Inbox",
        icon: "fa-inbox",
        count: null,
      });
    }

    // ─── Sent Emails tab (admin / super_admin only) ───
    if (isAdminLike) {
      menuItems.push({
        id: "sent_emails",
        label: "Sent Emails",
        icon: "fa-paper-plane",
        count: null,
      });
    }

    if (hasPermission("notifications"))
      menuItems.push({
        id: "notifications",
        label: "Notifications",
        icon: "fa-bell",
        count: null,
      });
    if (hasPermission("settings"))
      menuItems.push({
        id: "settings",
        label: "Settings",
        icon: "fa-gear",
        count: undefined,
      });
  }

  // If the current tab isn't in the user's menu, snap to the first available tab
  useEffect(() => {
    if (menuItems.length === 0) return;
    if (!menuItems.find((m) => m.id === activeTab)) {
      setActiveTab(menuItems[0].id);
    }
  }, [menuItems.map((m) => m.id).join(",")]);

  const renderContent = () => {
    switch (activeTab) {
      case "users":
        return <UsersManagement onlineUsers={onlineUsers} />;
      case "staff":
        return <StaffManagement />;
      case "team_leads":
        return <TeamLeadsList />;
      case "team-lead-panel":
        return <TeamLeadPanel />;
      case "kyc":
        return <KycVerification />;
      case "leads":
        return isStaff ? (
          <StaffLeadPanel />
        ) : isManager ? (
          <ManagerLeadPanel />
        ) : (
          <LeadManagement />
        );
      case "groxion_leads":
        return isStaff ? (
          <StaffLeadPanel />
        ) : isManager ? (
          <ManagerLeadPanel />
        ) : (
          <GroxionLead />
        );
      case "retention_leads":
        return isStaff ? (
          <StaffLeadPanel />
        ) : isManager ? (
          <ManagerLeadPanel />
        ) : (
          <RetentionLead />
        );

      // ─── NEW: Retention Data Tab Rendering ───
      case "retention_data":
        return <RetentionData />;
      // ─── End NEW ───

      case "missed_calls":
        return <MissedCalls />;
      case "inbox":
        return <StaffInbox />;
      case "master_inbox":
        return <AdminMasterInbox />;
      case "sent_emails":
        return <SentEmails />;

      case "affiliates":
        return <AffiliateList />;
      case "credit":
        return <CreditManagement />;
      case "trades":
        return <AllTrades />;
      case "deposits":
        return <DepositsWithdrawals type="deposits" />;
      case "withdrawals":
        return <DepositsWithdrawals type="withdrawals" />;
      case "swap":
        return <SwapManagement />;
      case "notifications":
        return <NotificationsTab />;
      case "settings":
        return <Settings />;
      default:
        return isTeamLead ? (
          <TeamLeadPanel />
        ) : isStaff ? (
          <StaffLeadPanel />
        ) : isManager ? (
          <ManagerLeadPanel />
        ) : (
          <UsersManagement onlineUsers={onlineUsers} />
        );
    }
  };

  const statCards = [
    {
      label: "TOTAL USERS",
      value: stats.totalUsers || 0,
      color: "#1e3a5f",
      icon: "fa-users",
      isUSD: false,
    },
    {
      label: "TOTAL DEPOSITS",
      value: stats.totalDeposits || 0,
      color: "#059669",
      icon: "fa-circle-plus",
      isUSD: true,
    },
    {
      label: "TOTAL WITHDRAWALS",
      value: stats.totalWithdrawals || 0,
      color: "#dc2626",
      icon: "fa-circle-minus",
      isUSD: true,
    },
    {
      label: "ACTIVE TRADERS",
      value: stats.activeTraders || 0,
      color: "#2563eb",
      icon: "fa-chart-line",
      isUSD: false,
    },
  ];

  const getNotifInfo = (notif) => {
    if (notif.type === "withdrawal_request")
      return {
        icon: "fa-circle-minus",
        color: "#dc2626",
        label: `WITHDRAWAL: $${Number(notif.amount).toFixed(2)}`,
      };
    if (notif.type === "credit_request")
      return {
        icon: "fa-credit-card",
        color: "#2563eb",
        label: `CREDIT: $${Number(notif.amount).toFixed(2)}`,
      };
    if (notif.page === "/deposit")
      return { icon: "fa-circle-plus", color: "#059669", label: "DEPOSIT" };
    if (notif.page === "/withdrawal")
      return { icon: "fa-circle-minus", color: "#dc2626", label: "WITHDRAWAL" };
    if (notif.page === "/documents")
      return { icon: "fa-file-shield", color: "#d97706", label: "KYC" };
    return { icon: "fa-circle-info", color: "#1e3a5f", label: "PAGE" };
  };

  const formatTimeAgo = (t) => {
    if (!t) return "";
    const diff = Date.now() - new Date(t).getTime();
    const secs = Math.floor(diff / 1000);
    if (secs < 60) return "just now";
    if (secs < 3600) return `${Math.floor(secs / 60)}m ago`;
    if (secs < 86400) return `${Math.floor(secs / 3600)}h ago`;
    return `${Math.floor(secs / 86400)}d ago`;
  };

  const handleLogout = async () => {
    try {
      await adminApi.post("/admin/auth/logout");
    } catch (e) {}
    localStorage.removeItem("adminToken");
    localStorage.removeItem("adminUser");
    if (socketRef.current) {
      socketRef.current.disconnect();
      socketRef.current = null;
    }
    if (tickTimerRef.current) clearInterval(tickTimerRef.current);
    dispatch(adminLogout());
    window.location.href = "/admin/login";
  };

  const SidebarContent = ({ collapsed }) => (
    <div className="p-2 md:p-3">
      {menuItems.map((item) => (
        <button
          key={item.id}
          onClick={() => {
            setActiveTab(item.id);
            setMobileSidebarOpen(false);
          }}
          className={`w-full flex items-center gap-2 md:gap-3 px-2 md:px-3 py-2.5 md:py-3 rounded-xl transition-all mb-1 font-extrabold ${activeTab === item.id ? "bg-[#eff6ff] border-l-[3px] border-[#1e3a5f] text-[#1e3a5f]" : "text-[#64748b] hover:bg-[#f8fafc] hover:text-[#0f172a]"}`}
        >
          <i
            className={`fas ${item.icon} text-xs md:text-sm ${activeTab === item.id ? "text-[#1e3a5f]" : "text-[#94a3b8]"}`}
          />
          {!collapsed && (
            <>
              <span className="flex-1 text-left text-[10px] md:text-[11px] uppercase tracking-wider font-syne truncate">
                {item.label}
              </span>
              {item.count !== undefined && item.count !== null && (
                <span
                  className={`text-[8px] md:text-[9px] font-mono font-extrabold px-1.5 md:px-2 py-0.5 rounded-full ${activeTab === item.id ? "bg-[#1e3a5f] text-white" : "bg-[#f1f5f9] text-[#64748b]"}`}
                >
                  {item.count}
                </span>
              )}
            </>
          )}
        </button>
      ))}
    </div>
  );

  return (
    <div className="min-h-screen bg-white">
      <FontStyles />
      <div className="fixed inset-0 pointer-events-none z-0 overflow-hidden">
        <div className="absolute w-[700px] h-[700px] rounded-full bg-gradient-radial from-[rgba(30,58,95,0.03)] to-transparent top-[-260px] right-[-200px] animate-float" />
        <div className="absolute w-[600px] h-[600px] rounded-full bg-gradient-radial from-[rgba(59,130,246,0.02)] to-transparent bottom-[-200px] left-[-160px] animate-float animation-delay-2000" />
      </div>

      {celebration && (
        <CelebrationPopup
          notification={celebration}
          onClose={() => setCelebration(null)}
        />
      )}

      {/* Topbar */}
      <div className="fixed top-0 left-0 right-0 h-[60px] z-[200] bg-white border-b-2 border-[#e2e8f0] flex items-center justify-between px-3 md:px-5 shadow-sm">
        <div className="flex items-center gap-2 md:gap-3">
          <button
            onClick={() => setMobileSidebarOpen(!mobileSidebarOpen)}
            className="md:hidden w-9 h-9 rounded-lg bg-[#f8fafc] border-2 border-[#e2e8f0] flex items-center justify-center text-[#64748b]"
          >
            <i
              className={`fas ${mobileSidebarOpen ? "fa-times" : "fa-bars"} text-sm`}
            />
          </button>
          <div className="flex items-center gap-2">
            <div className="w-8 h-8 md:w-9 md:h-9 rounded-lg bg-gradient-to-br from-[#0b1e33] to-[#1e3a5f] flex items-center justify-center shadow-md shadow-[#1e3a5f]/25">
              <span className="font-syne text-xs md:text-sm font-extrabold text-white">
                G
              </span>
            </div>
            <span className="font-syne font-extrabold text-[#0b1e33] text-sm md:text-base hidden sm:inline uppercase tracking-tight">
              AnzoTrade <span className="text-[#1e3a5f]">ADMIN</span>
            </span>
          </div>
          <div className="hidden md:block w-px h-6 bg-[#e2e8f0]" />
          <span className="hidden md:inline text-[10px] font-mono font-extrabold text-[#1e3a5f] bg-[#eff6ff] border-2 border-[#bfdbfe] px-2.5 py-0.5 rounded-lg uppercase tracking-wider">
            {user?.role?.replace(/_/g, " ") || "admin"}
          </span>
        </div>
        <div className="flex items-center gap-1.5 md:gap-3">
          {isStaff && (
            <span className="hidden md:inline text-[10px] font-mono font-extrabold text-[#1e3a5f] bg-[#eff6ff] border-2 border-[#bfdbfe] px-2.5 py-1 rounded-lg uppercase tracking-wider">
              Staff: {user?.firstName}
            </span>
          )}
          {isManager && (
            <span className="hidden md:inline text-[10px] font-mono font-extrabold text-[#0d9488] bg-[#f0fdfa] border-2 border-[#99f6e4] px-2.5 py-1 rounded-lg uppercase tracking-wider">
              Manager: {user?.firstName}
            </span>
          )}
          {isTeamLead && (
            <span className="hidden md:inline text-[10px] font-mono font-extrabold text-[#1e3a5f] bg-[#eff6ff] border-2 border-[#bfdbfe] px-2.5 py-1 rounded-lg uppercase tracking-wider">
              TL ({user?.staffType || "conversion"}): {user?.firstName}
            </span>
          )}

          <button
            onClick={() => fetchDashboardData(false)}
            disabled={isRefreshing}
            className="w-8 h-8 md:w-9 md:h-9 rounded-lg bg-[#f8fafc] border-2 border-[#e2e8f0] flex items-center justify-center text-[#64748b] hover:text-[#1e3a5f] hover:border-[#1e3a5f] transition-all"
          >
            <i
              className={`fas fa-sync-alt text-xs md:text-sm ${isRefreshing ? "animate-spin" : ""}`}
            />
          </button>

          {isAdminLike && (
            <div className="relative" ref={notifPanelRef}>
              <button
                onClick={() => {
                  setShowNotifPanel(!showNotifPanel);
                  if (!showNotifPanel) setUnreadAdminNotifs(0);
                }}
                className="relative w-8 h-8 md:w-9 md:h-9 rounded-lg bg-[#f8fafc] border-2 border-[#e2e8f0] flex items-center justify-center text-[#64748b] hover:text-[#1e3a5f] hover:border-[#1e3a5f] transition-all"
              >
                <i className="fas fa-bell text-xs md:text-sm" />
                {unreadAdminNotifs > 0 && (
                  <span className="absolute -top-1.5 -right-1.5 min-w-[18px] h-[18px] bg-[#dc2626] rounded-full text-[9px] font-extrabold font-mono text-white flex items-center justify-center px-1 border-2 border-white">
                    {unreadAdminNotifs > 99 ? "99+" : unreadAdminNotifs}
                  </span>
                )}
              </button>
              {showNotifPanel && (
                <div className="absolute top-full right-0 mt-2 w-72 md:w-80 bg-white border-2 border-[#e2e8f0] rounded-xl shadow-2xl z-[300] overflow-hidden animate-pop-in">
                  <div className="flex items-center justify-between px-4 py-3 border-b-2 border-[#e2e8f0] bg-[#f8fafc]">
                    <span className="font-syne text-xs font-extrabold text-[#0b1e33] uppercase tracking-wider">
                      <i className="fas fa-bolt text-[#1e3a5f] mr-1.5" /> LIVE
                      ALERTS
                    </span>
                    <button
                      onClick={() => {
                        setAdminNotifications([]);
                        setUnreadAdminNotifs(0);
                      }}
                      className="text-[9px] text-[#64748b] font-mono font-bold hover:text-[#dc2626] uppercase tracking-wider"
                    >
                      Clear all
                    </button>
                  </div>
                  <div className="max-h-72 overflow-y-auto">
                    {adminNotifications.length === 0 ? (
                      <div className="py-12 text-center">
                        <i className="fas fa-bell-slash text-2xl text-[#94a3b8] mb-2 block" />
                        <p className="text-[11px] text-[#64748b] font-mono font-bold">
                          No alerts yet
                        </p>
                      </div>
                    ) : (
                      adminNotifications.map((notif, idx) => {
                        const { icon, color, label } = getNotifInfo(notif);
                        return (
                          <div
                            key={idx}
                            className="px-4 py-3 border-b border-[#f1f5f9] hover:bg-[#f8fafc] flex gap-3 cursor-pointer transition-colors"
                            onClick={() => {
                              if (notif.type === "withdrawal_request")
                                setActiveTab("withdrawals");
                              else if (notif.type === "credit_request")
                                setActiveTab("credit");
                              else if (notif.page === "/deposit")
                                setActiveTab("deposits");
                              else if (notif.page === "/withdrawal")
                                setActiveTab("withdrawals");
                              else if (notif.page === "/documents")
                                setActiveTab("kyc");
                              setShowNotifPanel(false);
                            }}
                          >
                            <div
                              className="w-9 h-9 rounded-lg flex items-center justify-center flex-shrink-0 border-2"
                              style={{
                                background: `${color}15`,
                                borderColor: `${color}30`,
                              }}
                            >
                              <i
                                className={`fas ${icon} text-sm`}
                                style={{ color }}
                              />
                            </div>
                            <div className="flex-1 min-w-0">
                              <div className="text-[11px] text-[#0f172a] font-extrabold">
                                <span style={{ color }}>{notif.userName}</span>{" "}
                                → {label}
                              </div>
                              <div className="text-[9px] text-[#64748b] font-mono font-bold mt-1 flex items-center gap-2">
                                <span className="truncate">
                                  {notif.userEmail}
                                </span>
                                <span>·</span>
                                <span className="whitespace-nowrap">
                                  {formatTimeAgo(notif.timestamp)}
                                </span>
                              </div>
                            </div>
                            <div className="flex items-center">
                              <div
                                className="w-2.5 h-2.5 rounded-full border-2 border-white shadow-sm"
                                style={{ background: color }}
                              />
                            </div>
                          </div>
                        );
                      })
                    )}
                  </div>
                </div>
              )}
            </div>
          )}

          <div className="hidden sm:flex items-center gap-2">
            <div className="text-right">
              <div className="text-[9px] text-[#64748b] font-mono font-extrabold uppercase tracking-wider">
                Logged in as
              </div>
              <div className="text-[11px] font-extrabold text-[#0f172a]">
                {user?.email || "Admin"}
              </div>
            </div>
            <div className="w-9 h-9 rounded-full bg-gradient-to-br from-[#0b1e33] to-[#1e3a5f] flex items-center justify-center shadow-md shadow-[#1e3a5f]/25">
              <i className="fas fa-user-shield text-white text-xs" />
            </div>
          </div>

          <button
            onClick={handleLogout}
            className="flex items-center gap-1.5 px-2.5 md:px-3.5 py-1.5 md:py-2 rounded-lg bg-[#fef2f2] border-2 border-[#fecaca] text-[#dc2626] text-[9px] md:text-[10px] font-mono font-extrabold uppercase tracking-wider transition-all hover:bg-[#fee2e2] hover:border-[#fca5a5]"
          >
            <i className="fas fa-sign-out-alt text-[9px] md:text-[10px]" />
            <span className="hidden sm:inline">LOGOUT</span>
          </button>
        </div>
      </div>

      {/* Mobile Sidebar Overlay */}
      {mobileSidebarOpen && (
        <div
          className="fixed inset-0 bg-black/50 z-[180] md:hidden"
          onClick={() => setMobileSidebarOpen(false)}
        />
      )}

      {/* Desktop Sidebar */}
      <div
        className={`hidden md:block fixed left-0 top-[60px] bottom-0 bg-white border-r-2 border-[#e2e8f0] transition-all duration-300 z-20 shadow-sm ${sidebarCollapsed ? "w-[70px]" : "w-[260px]"}`}
      >
        <button
          onClick={() => setSidebarCollapsed(!sidebarCollapsed)}
          className="absolute -right-3 top-4 w-6 h-6 rounded-full bg-white border-2 border-[#e2e8f0] flex items-center justify-center text-[#1e3a5f] text-[10px] hover:bg-[#eff6ff] hover:border-[#1e3a5f] transition-all"
        >
          <i
            className={`fas fa-chevron-${sidebarCollapsed ? "right" : "left"}`}
          />
        </button>
        <SidebarContent collapsed={sidebarCollapsed} />
      </div>

      {/* Mobile Sidebar */}
      <div
        className={`md:hidden fixed left-0 top-[60px] bottom-0 bg-white border-r-2 border-[#e2e8f0] z-[190] shadow-xl transition-transform duration-300 ${mobileSidebarOpen ? "translate-x-0" : "-translate-x-full"} w-[260px]`}
      >
        <SidebarContent collapsed={false} />
      </div>

      {/* Main Content */}
      <div
        className={`pt-[70px] md:pt-[80px] transition-all duration-300 ${sidebarCollapsed ? "md:ml-[70px]" : "md:ml-[260px]"} p-3 md:p-6`}
      >
        {isAdminLike && (
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 md:gap-5 mb-4 md:mb-8">
            {statCards.map((card) => (
              <div
                key={card.label}
                className="bg-white border-2 border-[#e2e8f0] rounded-xl p-3 md:p-5 transition-all hover:border-[#1e3a5f] hover:shadow-lg"
              >
                <div className="flex items-center justify-between">
                  <div>
                    <div className="text-[8px] md:text-[9px] text-[#64748b] font-mono font-extrabold uppercase tracking-wider mb-1 md:mb-2">
                      {card.label}
                    </div>
                    <div
                      className="text-lg md:text-2xl font-extrabold"
                      style={{ color: card.color }}
                    >
                      {card.isUSD ? fmtUSD(card.value) : card.value}
                    </div>
                  </div>
                  <div
                    className="w-8 h-8 md:w-11 md:h-11 rounded-xl flex items-center justify-center border-2"
                    style={{
                      background: `${card.color}15`,
                      borderColor: `${card.color}30`,
                    }}
                  >
                    <i
                      className={`fas ${card.icon} text-sm md:text-lg`}
                      style={{ color: card.color }}
                    />
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
        <div className="bg-white border-2 border-[#e2e8f0] rounded-xl overflow-x-auto shadow-sm">
          {renderContent()}
        </div>
      </div>

      <style>{`@keyframes float{0%,100%{transform:translate(0,0)}50%{transform:translate(28px,-28px)}}.animate-float{animation:float 20s ease-in-out infinite}.animation-delay-2000{animation-delay:-8s}@keyframes pop-in{from{opacity:0;transform:scale(.93)}to{opacity:1;transform:scale(1)}}.animate-pop-in{animation:pop-in .2s ease}`}</style>
    </div>
  );
};

export default AdminDashboard;        